import React from "react"
import { 
  Button, 
  OverlayTrigger,
  Tooltip
} from "react-bootstrap"
import {
  HiArrowSmLeft
} from 'react-icons/hi'
import {
  ButtonCreateInterface
} from '../ButtonCreate'

export const ButtonBack: React.FC <ButtonCreateInterface> = ({
  text,
  noText = false,
  variant,
  tooltip = true,
  tooltipText,
  tooltipPlacement,
  size = 'sm',
  ...rest
}) => {
  return (
    <OverlayTrigger
      placement={tooltipPlacement}
      overlay={tooltip ? <Tooltip>{tooltipText ?? 'Kembali ke halaman sebelumnya'}</Tooltip> : <div></div>}
    >
      <Button
        {...rest}
        size={size === "sm" ? "sm" : size === "lg" ? "lg" : undefined}
        variant={variant ?? "outline-dark"}
      >
        <div className="d-flex justify-content-center align-items-center">
          <div>
            <HiArrowSmLeft className="mb-1" />
          </div>
          {!noText && (
            <span className="mx-1 text-uppercase">
              {text  ? text : 'Kembali'}
            </span>
          )}
        </div>
      </Button>
    </OverlayTrigger>
  )
}